import {useEffect} from "react";

import { HeadWrapper } from "../elements";
import noaccess from "./NoAccess.module.scss";
import {keycloak} from "../keycloak-config";

const NoAccessPage = () => {

  useEffect(() => {
    if (!keycloak.authenticated) {
      keycloak.login();
    }
  }, []);

  return (
    <div className={noaccess.noaccess}>
    <HeadWrapper
      href="https://developer.staq.io/noAccessPage"
    />
    <p>You do not have permission to view this page.</p>
    <p>Contact technical support.</p>
      <a href={keycloak.createLoginUrl()}>Return to Login</a>
    </div>
  );
};

export default NoAccessPage;
